module.exports = __webpack_public_path__ + "static/media/lat_light@2x.7217083e.png";